import { RECEIVE_DATA } from '../actions';

const data = (state = [], action) => {
  switch (action.type) {
    case RECEIVE_DATA:
      return action.data.data;
  default:
    return state;
  }
}

export default data;
